// Posições e ordem dos confrontos transcritas de SUPERS.xlsx.
// S.8: J/L × Q/S (linhas 5–18); S8 DUPLA FIXA: J × O (6–33);
// S10: O/Q × X/Z (6–10, 14–18, 24–28, 32–36);
// Super 10 normal: distribuição "10 Player Doubles Round Robin" enviada
// pelo usuário, com 15 rodadas, dois jogos e dois atletas de folga por rodada;
// S12: J/L × Q/S (5–37). O Super 16 foi transcrito da distribuição
// "16 Player Doubles Round Robin". Cada entrada é um jogo, não uma rodada inteira.
const Supers = (() => {
  const super8 = [
    [[1,5],[7,8]], [[2,3],[4,6]], [[4,7],[6,8]], [[1,2],[3,5]],
    [[3,4],[5,7]], [[2,6],[1,8]], [[1,6],[4,5]], [[3,7],[2,8]],
    [[5,6],[2,7]], [[1,4],[3,8]], [[4,8],[2,5]], [[6,7],[1,3]],
    [[1,7],[2,4]], [[3,6],[5,8]],
  ];
  const fixed8 = [
    [[1],[8]], [[2],[7]], [[3],[6]], [[4],[5]],
    [[1],[7]], [[8],[6]], [[2],[5]], [[3],[4]],
    [[1],[6]], [[7],[5]], [[8],[4]], [[2],[3]],
    [[1],[5]], [[6],[4]], [[7],[3]], [[8],[2]],
    [[1],[4]], [[5],[3]], [[6],[2]], [[7],[8]],
    [[1],[3]], [[4],[2]], [[5],[8]], [[6],[7]],
    [[1],[2]], [[3],[8]], [[4],[7]], [[5],[6]],
  ];
  const super12 = [
    [[1,12],[9,10]], [[2,8],[3,6]], [[4,11],[5,7]],
    [[4,6],[3,10]], [[2,5],[1,7]], [[8,9],[11,12]],
    [[3,9],[4,7]], [[10,11],[2,12]], [[1,5],[6,8]],
    [[7,8],[10,12]], [[2,9],[3,5]], [[1,4],[11,6]],
    [[3,12],[1,11]], [[2,6],[7,9]], [[5,8],[4,10]],
    [[9,12],[6,7]], [[1,8],[2,4]], [[3,11],[5,10]],
    [[1,3],[7,11]], [[2,10],[4,9]], [[8,12],[5,6]],
    [[1,9],[3,8]], [[4,5],[7,12]], [[2,11],[6,10]],
    [[6,9],[5,11]], [[3,7],[8,10]], [[1,2],[4,12]],
    [[5,12],[2,3]], [[4,8],[9,11]], [[7,10],[1,6]],
    [[3,4],[6,12]], [[5,9],[1,10]], [[2,7],[8,11]],
  ];
  const super16 = [
    [[1,3],[4,7]], [[15,16],[8,13]], [[6,10],[5,14]], [[2,9],[11,12]],
    [[7,11],[6,15]], [[3,10],[12,13]], [[5,8],[2,4]], [[9,14],[1,16]],
    [[2,15],[3,6]], [[1,8],[10,11]], [[4,13],[5,9]], [[7,12],[14,16]],
    [[8,12],[1,7]], [[3,5],[6,9]], [[2,16],[10,15]], [[4,11],[13,14]],
    [[6,11],[13,16]], [[1,14],[2,5]], [[3,12],[4,8]], [[9,10],[7,15]],
    [[9,13],[2,8]], [[14,15],[5,12]], [[7,10],[4,6]], [[1,11],[3,16]],
    [[12,16],[5,10]], [[13,15],[1,4]], [[6,14],[8,9]], [[2,11],[3,7]],
    [[5,7],[8,11]], [[10,14],[3,9]], [[6,13],[1,15]], [[2,12],[4,16]],
    [[2,6],[1,10]], [[7,8],[5,13]], [[3,15],[12,14]], [[4,9],[11,16]],
    [[3,13],[5,16]], [[9,12],[6,8]], [[1,2],[7,14]], [[11,15],[4,10]],
    [[6,7],[4,12]], [[9,15],[1,5]], [[3,8],[10,16]], [[11,13],[2,14]],
    [[1,12],[5,11]], [[8,15],[2,3]], [[7,9],[10,13]], [[4,14],[6,16]],
    [[8,14],[4,15]], [[2,7],[9,16]], [[10,12],[1,13]], [[3,11],[5,6]],
    [[7,16],[5,15]], [[8,10],[11,14]], [[1,9],[3,4]], [[6,12],[2,13]],
    [[2,10],[4,5]], [[3,14],[7,13]], [[9,11],[12,15]], [[8,16],[1,6]],
  ];
  const five = [
    [[1,2],[4,5]], [[3,4],[2,5]], [[1,3],[2,4]],
    [[3,5],[1,4]], [[1,5],[2,3]],
  ];
  const shifted = (matches, offset) => matches.map(([a,b]) => [a.map((p) => p + offset), b.map((p) => p + offset)]);
  const tenGroups = [...five, ...shifted(five, 5)];
  const tenFinals = [...five, ...shifted(five, 5)];
  const super10Normal = [
    [[1,2],[3,4]], [[5,6],[7,8]],
    [[1,9],[2,3]], [[4,5],[6,10]],
    [[2,8],[4,10]], [[1,7],[3,9]],
    [[1,5],[7,9]], [[2,10],[6,8]],
    [[3,10],[4,6]], [[5,7],[8,9]],
    [[1,3],[2,4]], [[5,8],[7,10]],
    [[1,8],[6,9]], [[2,5],[3,7]],
    [[1,4],[2,7]], [[3,6],[9,10]],
    [[1,6],[3,5]], [[8,10],[4,9]],
    [[2,9],[6,7]], [[5,10],[4,8]],
    [[3,4],[5,6]], [[1,2],[7,8]],
    [[1,10],[2,6]], [[5,9],[3,4]],
    [[1,9],[2,10]], [[3,8],[4,7]],
    [[7,9],[2,10]], [[6,8],[1,5]],
    [[4,6],[5,7]], [[8,9],[3,10]],
  ];
  const super10NormalByes = [
    [9,10], [7,8], [5,6], [3,4], [1,2],
    [6,9], [4,10], [5,8], [2,7], [1,3],
    [9,10], [7,8], [5,6], [3,4], [1,2],
  ];
  const formats = {
    'super-6': { count: 6, games: Super6.rounds, perRound: 1, sheet: 'S.6' },
    'super-8': { count: 8, games: super8, perRound: 2, sheet: 'S.8' },
    'super-8-fixa': { count: 8, games: fixed8, perRound: 4, fixed: true, sheet: 'S8 DUPLA FIXA' },
    'super-10-normal': { count: 10, games: super10Normal, byes: super10NormalByes, perRound: 2, sheet: '10 Player Doubles Round Robin' },
    'super-10': { count: 10, games: tenGroups, perRound: 1, phases: true, sheet: 'S10' },
    'super-12': { count: 12, games: super12, perRound: 3, sheet: 'S12' },
    'super-16': { count: 16, games: super16, perRound: 4, sheet: 'distribuição Super 16' },
  };
  function format(id) { return formats[id] || null; }
  function athletesReady(item) {
    const data = format(item?.format);
    return !!data && Array.isArray(item.athletes) && item.athletes.length === data.count && item.athletes.every((name) => typeof name === 'string' && name.trim());
  }
  function groupStandings(item) {
    const a = Super6.standings(item.athletes.slice(0,5), item.scores?.slice(0,5), item.scoring, five);
    const b = Super6.standings(item.athletes.slice(5,10), item.scores?.slice(5,10), item.scoring, five);
    b.ranking.forEach((entry) => { entry.position += 5; });
    return { a, b, complete: a.completed === 5 && b.completed === 5 };
  }
  function finalSeeds(item) {
    if (!athletesReady(item) || !Super6.validConfig(item.scoring)) return null;
    const { a, b, complete } = groupStandings(item);
    if (!complete) return null;
    const third = [a.ranking[2], b.ranking[2]].sort(Super6.compareRankingEntries);
    return [a.ranking[0], b.ranking[0], a.ranking[1], b.ranking[1], third[0], third[1], a.ranking[3], b.ranking[3], a.ranking[4], b.ranking[4]].map((entry) => entry.position);
  }
  function matchAthleteIndexes(item, index) {
    const data = format(item?.format);
    const total = data?.phases ? 20 : data?.games.length || 0;
    if (!data || !Number.isInteger(index) || index < 0 || index >= total) return [];
    if (!data.phases || index < 10) return data.games[index].flat().map((position) => position - 1);
    const seeds = finalSeeds(item);
    if (!seeds) return [];
    const finalGroupOffset = index < 15 ? 0 : 5;
    const finalMatchIndex = index < 15 ? index - 10 : index - 15;
    return five[finalMatchIndex].flat().map((position) => seeds[finalGroupOffset + position - 1] - 1);
  }
  function matchState(item, index) {
    const value = Array.isArray(item?.matchStates) ? item.matchStates[index] : null;
    const startedAt = Date.parse(value?.startedAt || '');
    if (!value || !Number.isFinite(startedAt)) return null;
    const endedAt = Date.parse(value?.endedAt || '');
    return {
      startedAt: new Date(startedAt).toISOString(),
      court: String(value.court || '').trim() || null,
      endedAt: Number.isFinite(endedAt) && endedAt >= startedAt ? new Date(endedAt).toISOString() : null,
    };
  }
  function activeMatchState(item, index) {
    const value = matchState(item, index);
    if (!value || value.endedAt || Super6.isComplete(item?.scores?.[index], item?.scoring)) return null;
    return { startedAt: value.startedAt, court: value.court };
  }
  function matchAvailability(item, index) {
    const players = matchAthleteIndexes(item, index);
    const active = activeMatchState(item, index);
    if (!players.length) return { players, active, blocked: false, blockingIndex: -1 };
    const playerSet = new Set(players);
    const total = format(item?.format)?.phases ? 20 : format(item?.format)?.games.length || 0;
    let blockingIndex = -1;
    for (let candidate = 0; candidate < total; candidate += 1) {
      if (candidate === index || !activeMatchState(item, candidate)) continue;
      if (matchAthleteIndexes(item, candidate).some((player) => playerSet.has(player))) {
        blockingIndex = candidate;
        break;
      }
    }
    return { players, active, blocked: blockingIndex >= 0, blockingIndex };
  }
  function standings(item) {
    const data = format(item.format);
    return Super6.standings(item.athletes, item.scores, item.scoring, data.games);
  }
  function individualAthletes(item) {
    const data = format(item?.format);
    if (!data || !Array.isArray(item.athletes)) return [];
    if (data.fixed) {
      return item.athletes.flatMap((duo, teamIndex) => String(duo || '').split(' / ').slice(0, 2).map((name, playerIndex) => ({
        index: teamIndex * 2 + playerIndex,
        name: name.trim(),
        teamIndex,
      }))).filter((athlete) => athlete.name);
    }
    return item.athletes.map((name, index) => ({ index, name: String(name || '').trim(), teamIndex: index })).filter((athlete) => athlete.name);
  }
  function paymentFor(item, index) {
    const defaultAmount = Number.isSafeInteger(Number(item?.registrationFeeCents)) && Number(item.registrationFeeCents) >= 0
      ? Number(item.registrationFeeCents)
      : 0;
    const saved = Array.isArray(item?.payments) ? item.payments[index] : null;
    const amount = Number.isSafeInteger(Number(saved?.amountCents)) && Number(saved.amountCents) >= 0
      ? Number(saved.amountCents)
      : defaultAmount;
    return { amountCents: amount, paid: saved?.paid === true };
  }
  function financialSummary(item) {
    const athletes = individualAthletes(item);
    return athletes.reduce((summary, athlete) => {
      const payment = paymentFor(item, athlete.index);
      summary.expectedCents += payment.amountCents;
      if (payment.paid) {
        summary.receivedCents += payment.amountCents;
        summary.paidCount += 1;
      } else {
        summary.pendingCents += payment.amountCents;
      }
      return summary;
    }, { expectedCents: 0, receivedCents: 0, pendingCents: 0, paidCount: 0, totalCount: athletes.length });
  }
  function shuffledParticipants(item, athletes, random = Math.random) {
    const data = format(item?.format);
    if (!data || !Array.isArray(athletes) || athletes.length !== data.count) return { athletes: [], payments: [] };
    const savedPayments = Array.isArray(item?.payments) ? item.payments : [];
    const participants = athletes.map((name, index) => data.fixed
      ? { name, payments: [savedPayments[index * 2] ?? null, savedPayments[index * 2 + 1] ?? null] }
      : { name, payments: [savedPayments[index] ?? null] });
    for (let index = participants.length - 1; index > 0; index -= 1) {
      const draw = Number(random());
      const normalized = Number.isFinite(draw) ? Math.min(Math.max(draw, 0), 0.9999999999999999) : 0;
      const target = Math.floor(normalized * (index + 1));
      [participants[index], participants[target]] = [participants[target], participants[index]];
    }
    return {
      athletes: participants.map((participant) => participant.name),
      payments: participants.flatMap((participant) => participant.payments),
    };
  }
  return { format, athletesReady, groupStandings, finalSeeds, matchAthleteIndexes, matchState, activeMatchState, matchAvailability, standings, individualAthletes, paymentFor, financialSummary, shuffledParticipants, tenFinals, five };
})();
if (typeof globalThis !== 'undefined') globalThis.Supers = Supers;
if (typeof module !== 'undefined') module.exports = Supers;
